import { ref } from 'vue'
import debounce from 'lodash/debounce'

/**
 * *(AI-generated)*
 * Composable that observes an element for resize changes and provides reactive width/height values.
 */
export const useOnResize = (el: HTMLElement) => {
  const width = ref(el.clientWidth)
  const height = ref(el.clientHeight)

  const handleResize = () => {
    // Use same mobile breakpoint
    width.value = el.clientWidth
    height.value = el.clientWidth
  }

  const resizeObs = new ResizeObserver(
    debounce(() => {
      handleResize()
    }, 1000)
  )
  resizeObs.observe(el)

  const remove = () => resizeObs.disconnect()

  return { width, height, remove }
}
